module.exports = __webpack_public_path__ + "static/media/sample_candidates.5ae33f75.csv";